import React, { memo, useEffect, useState } from 'react'
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { useDispatch } from 'react-redux';
import { setSelectedBranchOfficeData, setSelectedEquipmentTypeData, setSelectedModelData, setSelectedPanelTypedata } from 'redux/pages/Reports/SalesActivitySlice';
import { setSelectedBranchOfficeListForSystemReport, setSelectedPanelTypeForSystemReport, setSelectedSystemStatusForSystemReport } from 'redux/pages/Reports/SystemReportSlice';

interface CommonFilterType {
    showModal: boolean;
    onHide: (checkedData) => void;
    gridData?: any;
    selectedData?: any;
    field?: any;
    header?: any;
    title?: any;
    dataKey?: any;
    filterIdentifier?: any;
}

const CommonFilter: React.FC<CommonFilterType> = (props) => {
    const { showModal, onHide = () => { }, gridData, selectedData, field, header, title, dataKey, filterIdentifier } = props;
    const [selection, setSelection] = useState(null)
    const dispatch = useDispatch<any>();

    useEffect(() => {
        if (selectedData) {
            setSelection(selectedData)
        }
    }, [selectedData])

    useEffect(() => {
        if (filterIdentifier === "Branch Offices") {
            dispatch(setSelectedBranchOfficeData(selection))
        } else if (filterIdentifier === "Panel Types") {
            dispatch(setSelectedPanelTypedata(selection))
        } else if (filterIdentifier === "Equipment Types") {
            dispatch(setSelectedEquipmentTypeData(selection))
        } else if (filterIdentifier === "Models") {
            dispatch(setSelectedModelData(selection))
        } else if (filterIdentifier === "System Report Branch Offices") {
            dispatch(setSelectedBranchOfficeListForSystemReport(selection))
        } else if (filterIdentifier === "System Report Panel Types") {
            dispatch(setSelectedPanelTypeForSystemReport(selection))
        } else if (filterIdentifier === "System Report System Status") {
            dispatch(setSelectedSystemStatusForSystemReport(selection))
        }
    }, [selection])

    return (
        <Dialog
            showHeader={false}
            visible={showModal}
            onHide={() => onHide(selection)}
            className="SalesActivity"
        >
            <div className="custom-header">
                <div className="row">
                    <div className="col-6 box py-1 pr-0 pl-1">
                        <div className="title">{title}</div>
                    </div>

                    <div className="col-6 box py-1 pl-0 align-items-end pr-1">
                        <i className="pi pi-times" onClick={() => { onHide(selection) }}></i>
                    </div>
                </div>
            </div>
            <div className='custom-table'>
                <DataTable
                    value={gridData}
                    selection={selection}
                    onSelectionChange={e => setSelection(e.value)}
                    dataKey={dataKey}
                    responsiveLayout="scroll">
                    <Column selectionMode="multiple" headerStyle={{ width: '3em' }}></Column>
                    <Column field={field} header={header}></Column>
                </DataTable> 
            </div>
        </Dialog>
    )
}

export default memo(CommonFilter);



  